class FrontendDebugLogger {
    constructor() {
        this.logs = [];
        this.maxLogs = 1000; // Maksimum log say�s�

        let manualDebugFlag = false;
        try {
            if (typeof window !== 'undefined') {
                const params = new URLSearchParams(window.location.search);
                manualDebugFlag = params.has('debugLogs') ||
                    localStorage.getItem('MINELA_DEBUG_LOGS') === 'true';
            }
        } catch {
            manualDebugFlag = false;
        }

        const envFlag = process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true';
        this.isEnabled =
            process.env.NODE_ENV !== 'production' ||
            envFlag ||
            manualDebugFlag;
    }

    formatMessage(level, message, data = null) {
        const timestamp = new Date().toISOString();
        const logEntry = {
            timestamp,
            level,
            message,
            data: data || null,
            url: window.location.href,
            userAgent: navigator.userAgent
        };
        return logEntry;
    }

    addLog(level, message, data = null) {
        if (!this.isEnabled) return;

        const logEntry = this.formatMessage(level, message, data);
        this.logs.push(logEntry);

        // Maksimum log sayısını aşarsa eski logları sil
        if (this.logs.length > this.maxLogs) {
            this.logs = this.logs.slice(-this.maxLogs);
        }

        // Console'a yazdır
        const consoleMethod = level === 'error' ? 'error' : 
                             level === 'warn' ? 'warn' : 
                             level === 'debug' ? 'debug' : 'log';
        
        console[consoleMethod](`[${level.toUpperCase()}] ${message}`, data || '');

        // LocalStorage'a kaydet (son 100 log)
        try {
            const recentLogs = this.logs.slice(-100);
            localStorage.setItem('frontend_debug_logs', JSON.stringify(recentLogs));
        } catch (error) {
            console.warn('Debug logları localStorage\'a kaydedilemedi:', error);
        }
    }

    info(message, data = null) {
        this.addLog('info', message, data);
    }

    error(message, data = null) {
        this.addLog('error', message, data);
    }

    warn(message, data = null) {
        this.addLog('warn', message, data);
    }

    debug(message, data = null) {
        this.addLog('debug', message, data);
    }

    // API istekleri için özel log
    apiRequest(endpoint, options = {}) {
        this.info('API Request', {
            endpoint,
            method: options.method || 'GET',
            headers: options.headers,
            body: options.body,
            timestamp: new Date().toISOString()
        });
    }

    apiResponse(endpoint, response, data = null) {
        this.info('API Response', {
            endpoint,
            status: response.status,
            statusText: response.statusText,
            data: data,
            timestamp: new Date().toISOString()
        });
    }

    apiError(endpoint, error, response = null) {
        this.error('API Error', {
            endpoint,
            error: error.message,
            status: response?.status,
            statusText: response?.statusText,
            responseData: response,
            timestamp: new Date().toISOString()
        });
    }

    // Tüm logları getir
    getLogs() {
        return this.logs;
    }

    // Logları temizle
    clearLogs() {
        this.logs = [];
        localStorage.removeItem('frontend_debug_logs');
    }

    // Logları dışa aktar
    exportLogs() {
        return JSON.stringify(this.logs, null, 2);
    }

    // LocalStorage'dan logları yükle
    loadFromStorage() {
        try {
            const storedLogs = localStorage.getItem('frontend_debug_logs');
            if (storedLogs) {
                this.logs = JSON.parse(storedLogs);
            }
        } catch (error) {
            console.warn('Stored logs yüklenemedi:', error);
        }
    }

    // Global window objesine ekle (debug için)
    attachToWindow() {
        if (typeof window !== 'undefined') {
            window.debugLogger = this;
            window.getDebugLogs = () => this.getLogs();
            window.clearDebugLogs = () => this.clearLogs();
            window.exportDebugLogs = () => this.exportLogs();
        }
    }
}

const frontendDebugLogger = new FrontendDebugLogger();

// Sayfa yüklendiğinde localStorage'dan logları yükle
if (typeof window !== 'undefined') {
    frontendDebugLogger.loadFromStorage();
    frontendDebugLogger.attachToWindow();
}

export default frontendDebugLogger;
